import UnitDetails, {
    getServerSideProps as gSSP,
} from '@oberoninternal/travelbase-website/dist/components/pages/UnitDetail';
import React, { FC } from 'react';
import { GetServerSideProps } from 'next';
import addGlobalQuery from '../../utils/addGlobalQuery';
import USPs from '../../components/USPs';
import Page from '@oberoninternal/travelbase-website/dist/components/Page';
import brandConfig from '../../constants/travelbaseBrandConfig';

const UnitDetailsNL: FC<React.PropsWithChildren<unknown>> = props => (
    <Page>
        <UnitDetails pageSlug="accommodaties" {...props} />
        <USPs />
    </Page>
);
export default UnitDetailsNL;

export const getServerSideProps: GetServerSideProps = async context => {
    const result = await gSSP(brandConfig, context);
    return addGlobalQuery(result, context.locale);
};
